import React from 'react';
import { Helmet } from 'react-helmet-async';

export const metadata = {
  title: 'Kosmix Dental Clinic - HSR Layout, Bengaluru',
  description: 'Expert care in painless root canals, dental implants, and cosmetic dentistry. Over 9 years of delivering healthy, confident smiles in Bengaluru.',
};

const PPC3Layout = ({ children }) => {
  return (
    <div className="ppc3-layout">
      <Helmet>
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />
        
        {/* Canonical Tag */}
        <link rel="canonical" href="https://www.kosmixdentalclinic.com/lp/ppc3" />
        
        {/* Open Graph Tags */}
        <meta property="og:title" content={metadata.title} />
        <meta property="og:description" content={metadata.description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.kosmixdentalclinic.com/lp/ppc3" />
        <meta property="og:site_name" content="Kosmix Dental Clinic" />
        <meta property="og:image" content="https://www.kosmixdentalclinic.com/ogtag.JPG" />
        
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={metadata.title} />
        <meta name="twitter:description" content={metadata.description} />
        <meta name="twitter:image" content="https://www.kosmixdentalclinic.com/ogtag.JPG" />
        
        {/* Google Tag Manager */}
        <script>
          {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-P8PRFDC7');`}
        </script>
      </Helmet>
      {children}
    </div>
  );
};

export default PPC3Layout;
